<template>
    <el-table
        style="width: 100%"
        max-height="500"
        :data="customers"
        @row-click="showDetail"
    >
        <el-table-column
            v-for="column in tableColumns"
            :key="column.label"
            :min-width="column.minWidth"
            :prop="column.prop"
            :label="column.label"
            :show-overflow-tooltip="true"
        />
    </el-table>
</template>

<script>
export default {
    name: "CustomersTable",
    props: {
        customers: {
            type: Array,
            required: true,
        },
    },
    data() {
        return {
            tableColumns: [
                {
                    prop: "id",
                    label: "ID",
                },
                {
                    prop: "name",
                    label: "Name",
                },
                {
                    prop: "contact",
                    label: "Contact",
                },
                {
                    prop: "phone",
                    label: "Phone Number",
                },
                {
                    prop: "email",
                    label: "Email",
                },
                {
                    prop: "notes",
                    label: "Notes",
                },
            ],
        };
    },
    methods: {
        showDetail(row) {
            this.$router.push(`/customer/${row.id}`);
        },
    },
};
</script>
